import { motion } from "framer-motion";
import { STATS } from "@/constants/testIds";

const STAT_ROW = [
  { k: "400+", label: "Sensor signals decoded" },
  { k: "62,400", label: "Supported vehicles" },
  { k: "3.1s", label: "Avg. diagnostic latency" },
  { k: "94%", label: "Repair accuracy vs. shop" },
];

const MARQUEE_MAKERS = [
  // German
  "PORSCHE", "BMW", "AUDI", "MERCEDES-BENZ", "VOLKSWAGEN", "OPEL", "SMART",
  // British
  "MCLAREN", "ASTON MARTIN", "ROLLS-ROYCE", "BENTLEY", "JAGUAR", "LAND ROVER",
  "MINI", "LOTUS",
  // Italian
  "FERRARI", "LAMBORGHINI", "MASERATI", "ALFA ROMEO", "FIAT", "PAGANI",
  // French
  "PEUGEOT", "RENAULT", "CITROËN", "BUGATTI", "DS AUTOMOBILES",
  // American
  "TESLA", "FORD", "CHEVROLET", "CADILLAC", "GMC", "DODGE", "JEEP", "RAM",
  "LINCOLN", "CHRYSLER", "BUICK", "RIVIAN", "LUCID",
  // Japanese
  "TOYOTA", "HONDA", "NISSAN", "MAZDA", "SUBARU", "LEXUS", "INFINITI",
  "ACURA", "MITSUBISHI", "SUZUKI",
  // Korean
  "HYUNDAI", "KIA", "GENESIS",
  // Swedish
  "VOLVO", "POLESTAR", "KOENIGSEGG",
  // Czech / Spanish
  "SKODA", "SEAT", "CUPRA",
  // Chinese
  "BYD", "NIO", "XPENG", "GEELY", "GREAT WALL",
  // Indian
  "TATA", "MAHINDRA",
  // Australian
  "HOLDEN",
];

export const StatsBar = () => {
  return (
    <section
      data-testid={STATS.section}
      className="relative border-y border-white/10 bg-obsidian"
    >
      {/* Infinite marquee of global car brands */}
      <div
        className="relative overflow-hidden border-b border-white/5 py-6"
        style={{
          maskImage:
            "linear-gradient(90deg, transparent 0, #000 8%, #000 92%, transparent 100%)",
          WebkitMaskImage:
            "linear-gradient(90deg, transparent 0, #000 8%, #000 92%, transparent 100%)",
        }}
      >
        <div className="marquee-track gap-14 whitespace-nowrap group-hover:[animation-play-state:paused]">
          {[...MARQUEE_MAKERS, ...MARQUEE_MAKERS].map((m, i) => (
            <span
              key={i}
              className="font-display text-xl sm:text-2xl text-white/25 tracking-tighter font-medium select-none"
            >
              {m} <span className="text-mclaren/60 mx-4">◆</span>
            </span>
          ))}
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-12 lg:py-16 grid grid-cols-2 md:grid-cols-4 gap-8">
        {STAT_ROW.map((s, i) => (
          <motion.div
            key={s.k}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            className="border-l border-white/10 pl-5"
          >
            <div className="font-display text-4xl sm:text-5xl font-semibold tracking-tighter text-white">
              {s.k}
            </div>
            <div className="mt-2 font-mono-tech text-[11px] uppercase tracking-widest text-white/40">
              {s.label}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default StatsBar;
